
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 45 45"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('rect',{attrs:{"width":"44","height":"44","x":".5","y":".5","stroke":"#FFF","rx":"7"}}),_c('path',{attrs:{"stroke":"#BF9C5F","stroke-width":"2","d":"M16.872 31.798l.085.374h18.415a.375.375 0 010-.749H16.957l-.085.375zm-3.77 0l-.084-.375H8.933a.375.375 0 010 .749h4.085l.084-.375zm1.886-2.586a2.589 2.589 0 012.587 2.585 2.589 2.589 0 01-5.177 0 2.59 2.59 0 012.59-2.585zm9.052-7.047l.084.37h11.248a.37.37 0 01-.372-.368c0-.212.168-.38.374-.38H24.125l-.085.378zm-3.772-.009l-.083-.37H8.935a.375.375 0 010 .75h11.247l.086-.38zm1.885-2.58a2.59 2.59 0 012.589 2.585c0 1.43-1.16 2.592-2.59 2.592a2.592 2.592 0 01-2.589-2.592 2.59 2.59 0 012.59-2.585zm7.547-7.035l.084.368h5.588a.372.372 0 01-.372-.368c0-.212.168-.38.374-.38h-5.587l-.087.38zm-3.767-.008l-.084-.372H8.935a.375.375 0 010 .748H25.85l.084-.376zm1.883-2.59a2.592 2.592 0 012.589 2.592 2.587 2.587 0 11-2.59-2.591z"}})])])
          )
        }
      }
    